module.exports = __webpack_public_path__ + "img/symbol_9.93897eb3.png";